import { sceneBackground, type SceneKey } from '@str/shared';
import type { CSSProperties } from 'react';

/** Background style for a media item: real file when present, gradient scene otherwise. */
export function mediaStyle(m: {
  url?: string | null;
  scene?: SceneKey | null;
  warm?: number;
}): CSSProperties {
  if (m.url)
    return {
      backgroundImage: `url("${m.url}")`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };
  return { background: sceneBackground(m.scene ?? 'dusk', m.warm ?? 0) };
}

export function sceneStyle(scene: SceneKey, warm = 0): CSSProperties {
  return { background: sceneBackground(scene, warm) };
}
